export default __webpack_public_path__ + "static/media/one-time-calendar.f7350536.svg";